import React, { FunctionComponent, useCallback, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { FormContainer } from './styles';
import { parsePrice } from '../../../../utils/utils';
import { rechargeFastag } from '../../Listing/promiseAction';
import { showToaster } from '../../../Toaster/action';
import { sendEvent2, sendToGA } from '../../../../utils/tracking';
import Input from '../../../UI/InputWithIcon';

const RechargeForm: FunctionComponent<{
  tagId: string;
  amount: number;
  vehicle: string;
  walletBal: number;
  updateAction: Function;
}> = ({ tagId, amount, vehicle, walletBal, updateAction }) => {
  const { register, handleSubmit } = useForm();
  const dispatch = useDispatch();

  const [error, setError] = useState('');
  const [isSubmitted, toggleIsSubmitted] = useState(false);

  const dispatchToStore = useCallback(
    (payload) =>
      dispatch(rechargeFastag(payload))
        .then((resp: any) => {
          const { data = {} } = resp;
          if (!data.success) {
            setError(data && data.message);
            toggleIsSubmitted(false);
            return;
          }
          updateAction(false);
          dispatch(showToaster({ msg: `Fastag Recharge successful for ${vehicle}.`, timeout: 2000, success: true }));
          toggleIsSubmitted(false);
        })
        .catch((err: any) => {
          setError(err && err.message);
          toggleIsSubmitted(false);
        }),
    // TODO: handle dependencies updateAction, vehicle
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch],
  );

  const onSubmit = (data?: any) => {
    let msg = '';
    const { amount } = data;
    sendEvent2(
      'recharge_btn',
      {
        event_action: 'click',
        event_category: 'ft_vehicle_recharge_pop_up',
        screen_name: 'ft_homescreen',
        target_product: 'fastag',
        event_platform: 'web',
        miscellaneous: JSON.stringify({
          amount: amount,
        }),
      },
      true,
    );
    if (!amount || isNaN(amount)) {
      msg = 'Invalid amount';
    } else if (amount > walletBal) {
      msg = 'Recharge amount cannot be greater that wallet balance';
    }
    if (msg) {
      setError(msg);
      toggleIsSubmitted(false);
    } else {
      setError('');
      toggleIsSubmitted(true);
      sendToGA('click', 'Manual Recharge', 'Fastag');
      dispatchToStore({ tagId, amount: +data.amount });
    }
  };
  useEffect(() => {
    sendEvent2(
      'pop_up_view',
      {
        event_action: 'view',
        event_category: 'ft_vehicle_recharge_pop_up',
        screen_name: 'ft_homescreen',
        miscellaneous: JSON.stringify({
          ft_balance: amount,
          wallet_balance: walletBal,
        }),
        target_product: 'fastag',
        event_platform: 'web',
      },
      true,
    );
  }, []);

  return (
    <FormContainer>
      <p className="fwb mb16">Recharge {vehicle}</p>
      <p className="small mb8">
        Fastag Balance: <span className="ml5 fwb">{parsePrice({ price: amount })}</span>
      </p>
      <p className="smaller">
        Wallet Balance: <span>{parsePrice({ price: walletBal })}</span>
      </p>
      <div className="mt24">
        <form className="form-container" onSubmit={handleSubmit(onSubmit)}>
          <p className="small mb8 font-light-grey form-label">Enter Amount</p>
          <div className="flex">
            <Input
              handleChange={() => setError('')}
              register={register}
              type="number"
              placeholder="1000"
              name="amount"
            />
            <input disabled={isSubmitted} className="form-btn" type="submit" value="Recharge" />
          </div>
          <p className={`form-error ${error ? 'mt8' : 'hide'}`}>{error}</p>
        </form>
      </div>
    </FormContainer>
  );
};

export default RechargeForm;
